import {KTIcon} from '../../../../../../../_metronic/helpers'

interface IListSearchClient {
  searchClientName: string
  setSearchClientName: (value: string) => void
}
const ListSearchClient = ({searchClientName, setSearchClientName}: IListSearchClient) => {
  return (
    <>
      <div className='mb-5'>
        <label className='form-label fs-6 fw-bold'>Pesquisar por cliente:</label>
        <div className='d-flex align-items-center position-relative my-1'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='name'
            className='form-control form-control-solid min-w-250px ps-14'
            placeholder='Pesquisar cliente'
            value={searchClientName}
            onChange={(e) => {
              setSearchClientName(e.target.value)
            }}
          />
        </div>
      </div>
    </>
  )
}

export {ListSearchClient}
